<template>
    <div class="row">
        <div class="col-sm-7">
            <strong>{{block.title}}</strong>
            <AppealTag v-if="block.otherSourceLabel" other>{{block.otherSourceLabel}}</AppealTag>
        </div>
        <div class="col-sm-5">
            <div class="float-sm-right request-action-item-right pr-2">
                <span class="small">{{block.occurredAt}}</span>
            </div>
        </div>
        <div class="col-12" v-if="block.line || block.sameSourceLabel || block.double">
            <p class="small text-muted">
                <template v-if="block.line">{{block.line}}</template>
                <template v-if="block.sameSourceLabel"><template v-if="block.line"> · </template>{{block.sameSourceLabel}}</template>
                <template v-if="block.double">
                    <template v-if="block.line || block.sameSourceLabel"> · </template>
                    <router-link :to="{ name: 'request', params: {id: block.double.id} }">{{block.double.title}}</router-link>
                </template>
            </p>
        </div>
    </div>
</template>

<script>
    import AppealTag from "./AppealTag";

    // Повторное обращение клиента — звонок или лид: у каждого своя запись, строка самого звонка при этом не меняется.
    // Звонок: «на номер … · источник»; лид: «Источник: …» и ссылка на созданный им дубль. Первое обращение и статус дубля не показываем.
    // item.data готовит helpers/appeals.appealBlocks().
    export default {
        name: "RequestHistoryActionAppeal",
        components: {AppealTag},
        props: ['item'],
        computed: {
            block() {
                return this.item.data;
            },
        },
    }
</script>
